import { observable, makeObservable, computed, autorun } from 'mobx';
import { sessionStorage, localStorage } from 'js-storage';
import localeStore from './store.locale';

const getCallback = () => {
  const tmp = window.location.href.match(/\?callback=(.+)$/)?.[1];
  try {
    if (tmp) {
      return window.atob(tmp);
    }
  } catch (e) {
    console.error(e);
    return '';
  }
};

class GdmsStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  gdmsToken: string = localStorage.get('queryAuthorization') || '';

  @observable
  gdmsCallback: string =
    getCallback() || sessionStorage.get('guiconfig_gdms_callback') || '';

  @computed
  get isFromGdms() {
    return !!this.gdmsCallback && !!this.gdmsToken;
  }
}

const gdmsStore = new GdmsStore();

autorun(() => {
  sessionStorage.set('guiconfig_gdms_callback', gdmsStore.gdmsCallback);
});

autorun(() => {
  if (gdmsStore.isFromGdms && localStorage.get('lang') === 'zh-CN') {
    localeStore.updateLocale('zh');
  }
});

export default gdmsStore;
